module.exports = __webpack_public_path__ + "static/media/device_tablet.8f766ba3.svg";